// One place where the app-wide bars stack (at the TOP since 29/10/2026 — see below) — added with the Slack
// offer bar (Slack build step 2, 13/10/2026).
//
// ⚠️ WHY IT EXISTS: the trial countdown (BillingStatus), the account-closing countdown and the
// Slack offer each used to position themselves `fixed bottom-4` in the same spot. An admin
// on a trial who is also offered Slack would see one bar drawn on top of the other, with half
// of each unreadable and the wrong button under the mouse. Rendering each bar into this one
// container (with React's createPortal) stacks them instead.
//
// ⚠️ ONLY THE BARS LIVE HERE. The billing paywall is `fixed inset-0` and must stay outside:
// it covers the whole window on purpose, and the strip is a fixed, stacked container of
// its own (it was transformed to centre it until 29/10/2026 — keep the paywall outside).
export const BOTTOM_DOCK_ID = 'hh-bottom-dock';

// ⚠️ MOVED TO THE TOP, 29/10/2026 (Rob: the trial bar "blocks being able to see important
// things around the site … should be moved throughout the site to the top"; 4A — all three
// bars go). The name stays `bottomDock` so the three bars that use it didn't have to change;
// it is now a full-width strip fixed across the top of the window, and it PUSHES the page
// down: its height is kept in the CSS variable --hh-dock, which index.css adds to #root's
// top padding (NOT body's — a dialog's scroll lock zeroes that; see index.css) and the
// sidebar uses for its top and height. Empty strip → 0 → nothing moves.
// z-40 on purpose: below dialogs and their backdrops (z-50), which must cover it.
export function bottomDock() {
  if (typeof document === 'undefined') return null;
  let el = document.getElementById(BOTTOM_DOCK_ID);
  if (!el) {
    el = document.createElement('div');
    el.id = BOTTOM_DOCK_ID;
    el.className = 'fixed top-0 inset-x-0 z-40 flex flex-col';
    document.body.appendChild(el);
    const root = document.documentElement;
    const sync = () => root.style.setProperty('--hh-dock', `${el.offsetHeight}px`);
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(sync).observe(el);
    if (typeof MutationObserver !== 'undefined') new MutationObserver(sync).observe(el, { childList: true, subtree: true });
    sync();
  }
  return el;
}
